import { useEffect, useRef } from 'react';
import { useToastStore, type ToastTone } from '@/store/useToastStore';

/**
 * Shows a screen's "done" (or warning) message as a popup.
 *
 * The companion to useErrorPopup, for screens that already keep a message in
 * state ("Account saved.", "Invitation created."). When the message is set
 * the popup opens, and `clear` resets the state straight away — so the same
 * message said twice (saving the same form again) pops up twice.
 */
export function useFeedbackPopup(
  message: string | null | undefined | false,
  tone: ToastTone = 'success',
  clear?: () => void,
): void {
  const clearRef = useRef(clear);
  clearRef.current = clear;
  useEffect(() => {
    if (!message) return;
    useToastStore.getState().push(message, { tone });
    clearRef.current?.();
  }, [message, tone]);
}
